<template>
<transition name="modal">
    <div class="alert-modal">
        <div class="alert-area">
            <div class="md:py-6  md:p-8 form-design-color" id="alert_image_overlay">
                <img @click="closeForgetPasswordModal()" style="cursor:pointer;" id="close" src="@/assets/icons/login-close.png">
                <div class="md:py-4 p-5">
                        <div class="forget-password-header  pb-4 text-center">
                            Forgot Password?
                        </div>
                        <Form  @submit="onSubmit">
                            <div class="">
                                    <Field
                                    name="email"
                                    class="form-input"
                                    placeholder="E-mail Address"
                                    :rules="validateEmail"
                                    v-model="formData.email"
                                    />
                                    <div class="h-3 lg:h-5">
                                    <ErrorMessage name="email" class="form-error" />
                                    </div>
                            </div>
                            <div class="flex justify-center items-center">
                                <button :disabled="disableSubmission" :class="disableSubmission? 'disable-btn': ''" class=" new-app-btn bg-blue mt-6">
                                Submit
                                </button>
                            </div>
                        </Form>
                        <div class="flex justify-center items-center pt-4">
                            <span class="mb-2">
                            To login your account.
                            <a class="text-blue underline cursor-pointer" @click="openLoginselection()">
                                Click here!
                            </a>
                            </span>
                        </div>
                </div>
            </div>
        </div>
    </div>
  </transition>

</template>
<script>
import { mapActions } from 'vuex'
import VeeValidate from '@/shared/mixins/VeeValidate'
export default {
  name: 'ForgetPassword',
  mixins: [VeeValidate],
  data() {
    return {
      formData: {
        email: ''
      },
      disableSubmission: false
    }
  },
  methods: {
    ...mapActions ([
      'forgotPassword',
      'openForgetPasswordModal',
      'openLoginSelectionModal'
    ]),
    async onSubmit() {
        this.disableSubmission = true
        const response = await this.forgotPassword(this.formData)
        if (response.result) {
            this.closeForgetPasswordModal()
            this.$notify({
            group: 'buyHive',
            type: 'success',
            text: response.message
            });
        } else {
            this.$notify({
            group: 'buyHive',
            type: 'error',
            text: response.message
            });
        }
        this.disableSubmission = false
    },
    closeForgetPasswordModal() {
        this.openForgetPasswordModal(false)
    },
    openLoginselection() {
        this.openForgetPasswordModal(false)
        this.openLoginSelectionModal(true)
    }
  }
}
</script>


<style lang="scss" scoped>
.new-app-btn {
  @apply rounded-full px-16 py-2 text-white;
  font-size: 20px;
  line-height: 30px;
  font-weight: 500;
}
  .alert-modal {
    @apply fixed px-5 h-full inset-0 bg-dark z-50 bg-opacity-50 text-base flex  transition-all duration-150 ease-linear;
    .alert-area {
      @apply z-10 m-auto align-middle rounded-lg w-full;
      @screen md { width: 680px; }
      &__content {
        @apply rounded-lg;
        max-height: calc(100vh - 10px);
        overflow: auto;
        &__header {
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
          button {
            @apply text-lg font-bold w-1/2 py-2.5;
            @screen md { @apply text-2xl }
          }
        }
        .switch { @apply relative inline-block w-20 h-9; }
        .switch input { @apply h-0 w-0 h-0; }

        .slider {
          @apply absolute cursor-pointer inset-0;
          background-color: #00B3C9;
          -webkit-transition: .4s;
          transition: .4s;
        }

        .slider:before {
          @apply absolute bg-white h-7 w-7;
          
          left: 4px;
          bottom: 4px;
          -webkit-transition: .4s;
          transition: .4s;
        }

        input:checked + .slider { background-color: #8DC63F; }
        input:focus + .slider { box-shadow: 0 0 1px #8DC63F; }
        .slider.round { border-radius: 34px; }
        .slider.round:before { border-radius: 50%; }

        input:checked + .slider:before {
          -webkit-transform: translateX(42px);
          -ms-transform: translateX(42px);
          transform: translateX(42px);
        }
        .info-box {
          @apply pt-5 px-6 pb-2;
          background: rgba(0, 179, 201, 0.2);
          @screen md { @apply px-12 }
        }
      }
    }

    /* width */
    ::-webkit-scrollbar { width: 4px; }

    /* Track */
    ::-webkit-scrollbar-track { background: rgba(35, 31, 32, 0.15); }

    /* Handle */
    ::-webkit-scrollbar-thumb { background: #a0aec0; }
  }
#alert_image_overlay {
  margin: 1em auto;
  width: 90%;
  position: relative;
  color: #024457;
  z-index: 1001;
}
.disable-btn {
  background-color: #C4C4C4;
}
.disable-text {
  color: #C4C4C4;
}
.forget-password-header {
    @media(max-width: 768px) { 
     font-family: 'Avenir LT Pro';
    font-weight: 500;
    font-size: 24px;
    line-height: 26px;
  }
    display: flex;
    justify-content: center;
    color: #00B2C9;
    font-family: 'Avenir LT Pro';
    font-weight: 500;
    font-size: 28px;
    line-height: 38px;
}
.selection-content-text {
  @media(max-width: 768px) {
  font-weight: 500;
  font-size: 12px;
  line-height: 14.4px;
  }
  font-weight: 400;
  font-size: 16px;
  line-height: 19.2px;
}
.checkbox_image_overlay {
  border-radius: 8px;
  padding: 1em;
  position: relative;
  color: #024457;
  font-family: Arial;
  z-index: 1001;
}
.checkbox_image_overlay .checkbox_image_freelancer {
  position: absolute;
  top: 0px;
  right: 8px;
  
}
.checkbox_image_overlay .checkbox_image_buyer {
  position: absolute;
  top: 19px;
  right: 8px;
  
}
#alert_image_overlay #close {
  position: absolute;
  top: 13px;
  right: 13px;
  
}
#alert_image_overlay #alert_header {
  position: absolute;
  top: 45px;
  left: 40px;
  color: #2D2D84;
  font-size: 60px;
  line-height: 60px;
  font-weight: 600;
  font-style: Avenir;

}
#alert_image_overlay #alert_content {
  position: absolute;
  top: 170px;
  left: 40px;
  color: #243943;
  font-size: 24px;
  line-height: 32.78px;
  font-style: Avenir;

}
#alert_image_overlay #alert_button {
  position: absolute;
  top: 250px;
  left: 40px;
  background-color: #2D2D84;
  color: white;
  font-size: 24px;
  line-height: 40px;
  font-style: Avenir;

}
.buyer-selection {
  border: 1px solid #C4C4C4;
  border-radius: 4px;
}
.freelancer-checked {
  background: #FFFFFF;
  border: 1px solid #8BC53F !important;
  box-shadow: 1px 1px 6px 1px #C5DFE2;
  border-radius: 4px;
}
.buyer-checked {
  background: #FFFFFF;
  border: 1px solid #00B2C9 !important;
  box-shadow: 1px 1px 6px 1px #C5DFE2;
  border-radius: 4px;
}
.dont-have-account {
  @media(max-width: 768px) { 
    font-size: 14px;
    line-height: 14px;
  }
}
.freelancer-selection {
  border: 1px solid #C4C4C4;
  border-radius: 4px;
}
.login-selection-header {
  @media(max-width: 768px) { 
     font-family: 'Avenir LT Pro';
    font-weight: 500;
    font-size: 24px;
    line-height: 26px;
  }
    display: flex;
    justify-content: center;
    color: #00B2C9;
    font-family: 'Avenir LT Pro';
    font-weight: 500;
    font-size: 28px;
    line-height: 38px;
}
.form-design-color{
  background: linear-gradient(180deg, #DCFBFF 0%, #F9FFF0 100%);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}
</style>